module.exports = __webpack_public_path__ + "qrcode-weixin.7c38c99130.png";